import React from 'react'

import LoadingSpinner from '../../../../../components/atoms/LoadingSpinner'

import useStyles from './styles'

const Loading: React.FC = () => {
  const classes = useStyles()

  return (
    <React.Fragment>
      Loading
      <LoadingSpinner className={classes.spinner} />
    </React.Fragment>
  )
}

export default Loading
